export default {
  player: null,
  playerInfo: {
    play: 0, // 0暂停 1播放
    volume: 1, // 0静音 1有声音
    muted: false
  },
  ws: null,
  videoInfo: {
    videoSrc: '',
    cdnSrc: [],
    hlsSrc: ''
  },
  viewInfo: {
    shareBox: false,
    hasCopied: false,
    endBox: false,
    loading: false,
    videoBg: true,
    playBtn: false,
    controlBox: false,
    infoBox: false,
    leaveBox: false,
    appear: true,
    recommend1: {},
    recommend2: {},
    recommend3: {}
  },
  liveInfo: {
    app: '',
    siteid: ''
  },
  // 各时间点埋点统计
  times: {
    t1: Date.now(), // 初始的时间
    t2: 0, // 发出请求
    t3: 0, // 请求成功，拿到m3u8
    t4: 0, // 播放需要的资源准备完毕，开启播放器
    t5: 0, // 出视频
    t6: 0, // 开始下载第一个ts
    t7: 0 // 第一个ts下载完毕
  }
};
